import Touch from "./touch";

const install = function(Vue) {
  Vue.directive("longtap", {
    bind: function(el, binding) {
      new Touch(el, binding);
    }
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

Touch.install = install;
export default Touch;
